<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6085_26419)">
      <path
        d="M7 11.8333H12.25"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.625 2.20826C9.85706 1.9762 10.1718 1.84583 10.5 1.84583C10.6625
        1.84583 10.8234 1.87783 10.9735 1.94002C11.1237 2.00221 11.2601 2.09336
        11.375 2.20826C11.4899 2.32317 11.5811 2.45958 11.6432 2.60972C11.7054
        2.75985 11.7374 2.92076 11.7374 3.08326C11.7374 3.24576 11.7054 3.40668
        11.6432 3.55681C11.5811 3.70694 11.4899 3.84336 11.375 3.95826L4.08333
        11.2499L1.75 11.8333L2.33333 9.49993L9.625 2.20826Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6085_26419">
        <rect
          width="14"
          height="14"
          fill="currentColor"
          transform="translate(0 0.166626)"
        />
      </clipPath>
    </defs>
  </svg>
</template>